export default __webpack_public_path__ + "static/team-designhorf-5f7704693f0388f064ab0e7dda1daaf4.png";